import { mapState, mapGetters } from 'vuex';
import axios from '@/mod/axiosMod';
import { channel, source, ReportType } from '@/constants/ad';
import Api from '@/api/ad';
import tracker from '@/util/tracker';

export default {
  props: {
    slotCode: {
      type: Number,
      default: -1,
    },
    cid: {
      type: String,
      required: true,
    },
    mvBid: {
      type: String,
      required: true,
    },
    mcBid: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState(['currentPoi', 'bizlogintoken', 'poiList']),
    ...mapState('billModule', ['customerId']),
    ...mapGetters('adModule', ['getSlotInfoByCode', 'getShowSlot']),
    slotInfo() {
      return this.getSlotInfoByCode(this.slotCode);
    },
    showSlotInfo() {
      return this.getShowSlot(this.slotCode);
    },
    sizeStyle() {
      const { width, height } = this.slotInfo || {};
      return `width:${width / 100}rem;height:${height / 100}rem`;
    },
  },
  methods: {
    sendMV(resourceInfo, lxExt) {
      const { mvBid: bid, cid, slotCode } = this;
      const { sourceId, launchId, reportDataMap = {} } = resourceInfo;
      const valLab = {
        position_id: slotCode,
        adv_id: launchId,
        user_id: this.customerId,
        channel,
        source,
        reportDataMap,
        ...lxExt,
      };
      tracker.sendModuleView(bid, valLab, { cid });


      const type = ReportType.MV;
      const report = {
        slotCode, sourceId, userId: this.customerId, type, launchId,
      };
      Api.reportSource(report);

      const monitorData = resourceInfo.monitorData || {};
      const mvUrls = monitorData.mvUrls || [];
      mvUrls.forEach((url) => axios.get(url, { withCredentials: false, delToken: true }));
    },
    async sendMC(resourceInfo, lxExt) {
      const { mcBid: bid, cid, slotCode } = this;
      const { sourceId, launchId, reportDataMap = {} } = resourceInfo;
      const valLab = {
        position_id: slotCode,
        adv_id: launchId,
        user_id: this.customerId,
        channel,
        source,
        reportDataMap,
        ...lxExt,
      };
      tracker.sendModuleClick(bid, valLab, { cid });

      const type = ReportType.MC;
      const report = {
        slotCode, sourceId, userId: this.customerId, type, launchId,
      };
      Api.reportSource(report);

      const monitorData = resourceInfo.monitorData || {};
      const mcUrls = monitorData.mcUrls || [];
      mcUrls.forEach((url) => axios.get(url, { withCredentials: false, delToken: true }));
    },

    formatLandingPage(link, data = {}) {
      const poi = this.poiList[1] || this.poiList[0]; // copy from homePage
      const temp = {
        ...data,
        poiId: this.currentPoi.poiId || poi.poiId,
        BSID: this.bizlogintoken,
      };
      Object.keys(temp).forEach((item) => {
        link = String(link).replace(`$\{${item}}`, temp[item]);
      });
      return link;
    },
  },
};
